import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { GlobalProvider, globalReducer } from './context/GlobalContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import useHttp from './utils/http';

import Login from './pages/Login';
import DashboardPage from './pages/Dashboard';
import Operations from './pages/Operations';
import Print from './pages/Print';
import CustomerForm from './pages/CustomerForm';
import Customers from './pages/Customers';
import ProtectedRoute from './components/protectedRoute';
import HomeRedirect from './components/HomeRedirect';
import ListOperations from './pages/ListOperations';
import PrintedTags from './pages/ListPrintedTags';

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'

Bugsnag.start({
  apiKey: '762b3d791bad9ec6084a0842aba36185',
  plugins: [new BugsnagPluginReact()]
})
BugsnagPerformance.start({ apiKey: '762b3d791bad9ec6084a0842aba36185' })

const ErrorBoundary = Bugsnag.getPlugin('react')
  .createErrorBoundary(React)

// Componente separado para manejar el refresco del token
function AppContent() {
  const { isLoggedIn } = useAuth();
  const { refreshToken } = useHttp();

  useEffect(() => {
    if (isLoggedIn) {
      const intervalId = setInterval(() => {
        refreshToken();
      }, 30000); // Refresca cada 30 segundos el token

      return () => clearInterval(intervalId);
    }
  }, [isLoggedIn, refreshToken]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={<ProtectedRoute><DashboardPage /></ProtectedRoute>}
        />
        <Route
          path="/operations"
          element={
            <ProtectedRoute>
              <Operations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/print"
          element={<ProtectedRoute><Print /></ProtectedRoute>}
        />
        <Route path="/customer-form"
          element={<ProtectedRoute><CustomerForm /></ProtectedRoute>} />
        <Route path="/Customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
        <Route path="/list-operations" element={<ProtectedRoute><ListOperations /></ProtectedRoute>} />
        <Route path="/list-printed-tags" element={<ProtectedRoute><PrintedTags /></ProtectedRoute>} />
        <Route path="/" element={<HomeRedirect />} />
      </Routes>
    </Router>
  );
}

function App() {
  // Customizing the theme
  const customTheme = extendTheme({
    styles: {
      global: {
        '@media(min-width: 48em)': {
          'html, body': {
            overflow: 'hidden',
          },
          "select option": {
            fontFamily: '"Courier New", Courier, monospace',
          },
        },
      },
    },
  });

  return (
    <ErrorBoundary>
      <ChakraProvider theme={customTheme}>
        <GlobalProvider reducer={globalReducer}>
          <AuthProvider>
            <AppContent /> {/* Aquí colocamos el contenido de la aplicación */}
          </AuthProvider>
        </GlobalProvider>
      </ChakraProvider>
    </ErrorBoundary>
  );
}

export default App;
